/* tslint:disable:no-console */
import { __spreadArray } from "tslib";
import { LoggerImplQueued } from './LoggerImplQueued';
var KeyL = 76;
var Logger = /** @class */ (function () {
    function Logger(serviceName) {
        var _this = this;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = _this.impl).log.apply(_a, __spreadArray(["".concat(_this.serviceName, ":")], args, false));
        };
        this.info = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = _this.impl).info.apply(_a, __spreadArray(["".concat(_this.serviceName, ":")], args, false));
        };
        this.warn = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = _this.impl).warn.apply(_a, __spreadArray(["".concat(_this.serviceName, ":")], args, false));
        };
        this.error = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = _this.impl).error.apply(_a, __spreadArray(["".concat(_this.serviceName, ":")], args, false));
        };
        this.switchToRealtime = function () {
            _this.impl = console;
        };
        this.serviceName = serviceName;
        Logger.instances.push(this);
        this.impl = Logger.queueImpl;
    }
    Logger.switchAllToRealtime = function () {
        Logger.queueImpl.drain(console);
        Logger.instances.forEach(function (logger) { return logger.switchToRealtime(); });
    };
    Logger.cleanQueue = function () {
        Logger.queueImpl.clean();
    };
    Logger.instances = [];
    Logger.queueImpl = new LoggerImplQueued();
    return Logger;
}());
export { Logger };
// Show log when CTRL+ALT+SHIFT+L was pressed
var enableDebugHandler = function (event) {
    var ctrlKey = event.ctrlKey, shiftKey = event.shiftKey, metaKey = event.metaKey, altKey = event.altKey, keyCode = event.keyCode; // tslint:disable-line:deprecation
    var doesMatch = [
        ctrlKey || metaKey,
        altKey,
        shiftKey,
        keyCode === KeyL,
    ].every(Boolean);
    if (!doesMatch) {
        return;
    }
    Logger.switchAllToRealtime();
    detachEnableDebugHandler();
};
export var attachEnableDebugHandler = function () {
    return window.addEventListener('keydown', enableDebugHandler, false);
};
export var detachEnableDebugHandler = function () {
    return window.removeEventListener('keydown', enableDebugHandler, false);
};
//# sourceMappingURL=Logger.js.map